<template>
    <div>

        <!-- tool info -->
        <MessageSection class="flex items-center">
            <div style="width:700px;">
                <div class="mb2">
                    <h6 v-if="isRental" class="red">Rental Request:</h6>
                    <h6 v-else class="mid-gray">Rental Details:</h6>
                </div>
                <h6>{{rental.title}}</h6>
            </div>
            <img class="w3 h3" :src="rental.image"/>
        </MessageSection>

        <!-- times -->
        <MessageSection>
            <div :class="{'flex items-center justify-between' : !isRental}">
                <div>
                    <BoldedLabelDetail title="From: " :value="rental.startDate | moment('MMM DD, YYYY [at] h:mma')"/>
                    <BoldedLabelDetail title="To: " :value="rental.endDate | moment('MMM DD, YYYY [at] h:mma')"/>
                </div>
                <img v-if="!isRental" class="grow pointer" src="@/assets/img/icon_calendar_yellow.svg"/>
            </div>
        </MessageSection>

        <!-- handoff method and (possibly address) -->
        <MessageSection>
            <BoldedLabelDetail title="Handoff: " :value="rental.handoffMethod"/>
            <HandoffAddress :location="rental.location" />
        </MessageSection>

    </div>
</template>

<script>
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import BlackButton from '@/components/buttons/BlackButton.vue';
import HandoffAddress from '@/components/inbox/messagesCard/shared/rentalInfo/HandoffAddress.vue';
import BoldedLabelDetail from '@/components/controls/BoldedLabelDetail.vue';
import MessageSection from '@/components/inbox/messagesCard/shared/MessageSection.vue';

export default {
    components: {
        TooliabaButton,
        BlackButton,
        HandoffAddress,
        BoldedLabelDetail,
        MessageSection
    },
    props: {
        rental: {
            type: Object,
            default: function() {
                return [
                    {
                        title: 'Bostich 3.5-in Cordless Yellow Framing Nailer',
                        image: require('@/assets/img/tools/wrench.jpg'),
                        startDate: 'Jun 26, 2018 at 7:00am',
                        endDate: 'Jun 30, 2018 at 6:00pm',
                        handoffMethod: 'Owner Delivery Service'
                    }
                ];
            }
        },
        isRental: {
            type: Boolean,
            default: false
        }
    }
};
</script>
